import { FC, useState, useRef } from "react";
import clsx from "classnames";
import { map } from "lodash-es";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button, Header } from "@onmo/ui";
import { OnboardingSlideCard } from "../../components/common/OnboardingSlideCard";
import { ONBOARDING_SLIDES } from "../../constants/onboarding";
import { PageRoutes } from "../../constants/routes";
import { useStyles } from "./Onboarding.style";
import { useTranslation } from "react-i18next";

export const Onboarding: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideRef = useRef<Slider>(null);

  const slideSetting = {
    afterChange: (currentSlide: number) => setCurrentSlide(currentSlide),
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
  };

  const onNext = () => {
    if (currentSlide === ONBOARDING_SLIDES.length - 1) {
      onPlay();
      return;
    }
    if (slideRef.current) {
      slideRef.current.slickGoTo(currentSlide + 1);
      setCurrentSlide((prevSlide) => (prevSlide += 1));
    }
  };

  const onPlay = async () => {
    localStorage.setItem("hasOnboarded", "true");
    navigate(PageRoutes.Guest);
  };

  return (
    <div className={classes.root}>
      {currentSlide !== ONBOARDING_SLIDES.length - 1 && (
        <Header
          rightElement={
            <Button
              variant="borderless"
              className={classes.btnSkip}
              onClick={onPlay}
            >
              {t("skip")}
            </Button>
          }
        />
      )}
      <div className={classes.content}>
        <Slider {...slideSetting} ref={slideRef}>
          {map(ONBOARDING_SLIDES, (slide, idx) => (
            <OnboardingSlideCard key={idx} slide={slide} />
          ))}
        </Slider>
        <div className={classes.dots}>
          {map(ONBOARDING_SLIDES, (_, index) => (
            <div
              key={index}
              className={clsx(
                classes.dot,
                `${currentSlide === index ? "active" : ""}`,
              )}
            />
          ))}
        </div>
        <div className={classes.btnNext}>
          <Button
            variant={
              currentSlide === ONBOARDING_SLIDES.length - 1
                ? "contained"
                : "outlined"
            }
            fullWidth
            onClick={onNext}
            className={classes.btnPlay}
          >
            {currentSlide === ONBOARDING_SLIDES.length - 1
              ? t("play_now")
              : t("next")}
          </Button>
        </div>
      </div>
    </div>
  );
};
